<template>
  <div>
    <div class="roomChange">
      <div class="subTitle">个人信息</div>
      <div class="padding-20 bg-fff">
          <div class="listBox">
            <div class="mesList">
              <div class="title color-333 font-size-14px margin-top-8">姓名：{{item.reporterName}}</div>
              <p class="color-666 font-size-26 margin-top-8">上网账号：{{item.reporterNumber}}</p>
              <p class="color-666 font-size-26 margin-top-8">联系电话：{{item.reporterPhone}}</p>
            </div>
          </div>
        </div>

        <div class="subTitle margin-top-20">报修信息</div>
        <div class="padding-20 bg-fff">
          <div class="listBox">
            <div class="mesList">
              <p class="color-666 font-size-26 margin-top-8">报修类型：{{item.reportType}}</p>
              <p class="color-666 font-size-26 margin-top-8">报修位置：{{item.location}}</p>
              <p class="color-666 font-size-26 margin-top-8">报修时间：{{item.reportTime}}</p>
              <p class="color-666 font-size-26 margin-top-8">报修原因：{{item.reportCause}}</p>
              <p class="color-666 font-size-26 margin-top-8" v-if="item.reportCauseDescription">故障描述：{{item.reportCauseDescription}}</p>
            </div>
          </div>
        </div>

        <div v-if="item.repairerName">
          <div class="subTitle margin-top-20">维修师傅</div>
          <div class="padding-20 bg-fff">
            <div class="listBox">
              <div class="mesList">
                <p class="color-666 font-size-26 margin-top-8">网络维修人员：{{item.repairerName}}</p>
                <p class="color-666 font-size-26 margin-top-8">联系电话：{{item.repairerPhone}}</p>
              </div>
            </div>
          </div>
        </div>
        

        <div v-if="item.slips && item.slips.length > 0">
          <div class="subTitle margin-top-20">报修流水</div>
          <div class="padding-20 bg-fff">
            <div class="case-details">
              <div class="case-list">
                <div class="list" v-for="(item, index) in item.slips" :key="index">
                  <p class="title">{{item.slipType}}</p>
                  <div class="showitem">
                    <h4>{{item.slipTime}}</h4>
                    <div class="text">{{item.content}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        

    </div>

    <div class="grid bg-appStyle color-fff footer" v-if="item.buttons && item.buttons.length>0">
      <div class="gridWarp nopadding noborder">
        <div class="gridCell" v-for="(btnItem, key) of item.buttons" :key="key" @click="closeItem($event, btnItem, item)">
          {{btnItem}}
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import Vue from 'vue'
import { mapGetters } from "vuex";
import { Toast } from 'mint-ui';
import api from "../fetch/api";
import { MessageBox } from 'mint-ui';

import service from "@/fetch/service";
import * as types from '@/vuex/types';
export default {
  components: {},
  data() {
    return {
      Url: types.URL,
      showImgModal: false,
      item: {}
    };
  },
  created() {
    console.log(this.$route.query)
    console.log(this.$route.query.pageDate)
    this.getDate()
  },
  computed:{
    ...mapGetters([]),
    query: {
      get: function () {
          return this.$route.query;
      }
    }
  },
  mounted() {
    
  },
  methods: {
    //获取详情信息
    getDate() {
      let that = this
      this.$store.dispatch("setLoadingState", true);
      service
      .myNetWorkMaintainDetail({
        id: that.$route.query.pageDate.id
      })
      .then(res => {
        this.$store.dispatch("setLoadingState", false);
        let result = res.result;
        if (res.success) {
          that.item = result;
        }
        
      })
      .catch(error => {
        this.$store.dispatch("setLoadingState", false);
        console.log(error);
        Toast(error.data.msg);
      });
    },
    closeItem: function (event, type, item) {
      if(event) { 
        event.stopPropagation ? event.stopPropagation(): event.cancelBubble = true;
      }
      console.log(type)
      console.log(item)
      let that = this
      MessageBox.confirm('确定执行此操作?').then(action => {
        console.log(action)
        if (action == 'confirm') {
          if (type == '撤销申请') {
            that.handleApply(item, '/api/NetworkMaintain/cancelApply')
          }
          if (type == '未修好') {
            that.handleApply(item, '/api/NetworkMaintain/doNotRepairComplete')
          }
          if (type == '确认完成') {
            that.handleApply(item, '/api/NetworkMaintain/doCompleteReportOrder')
          }
        }
      });
    },
    /**
     * 撤销申请
     */
    handleApply: function (item, url) {
      let that = this
      this.$store.dispatch("setLoadingState", true);
      let params = {
        id: item.id
      }
      api.post(url, params)
      .then(res => {
        this.$store.dispatch("setLoadingState", false);
        Toast(res.msg);
        if (res.success) {
          setTimeout(() => {
            this.$router.go(-1);
          }, 500);
        }
      })
      .catch(error => {
        this.$store.dispatch("setLoadingState", false);
        console.log(error);
        Toast(error.data.msg);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/css/function";
$them-color: #03a9f4;
.footer {
  position: fixed;
  bottom: 0;
  width: 100%;
}
.footerBtn {
  width: 100%;
  height: px2rem(100px);
  background: $them-color;
  // position: fixed;
  // bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 14px;
}
.flex-basis-50 {
  flex-basis: 50% !important;
}
.imgModal {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(225, 225, 225, 225);
  top: 0;
  z-index: 1000;
  .img {
    width: 100%;
    height: px2rem(800px);
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    /* Internet Explorer */
    -moz-transform: translateY(-50%);
    /* Firefox */
    -webkit-transform: translateY(-50%);
    /* Safari 和 Chrome */
    -o-transform: translateY(-50%);
    /* Opera */
  }
}
.roomChange {
  margin-bottom: px2rem(130px);
  
  background: #f5f5f5;
  .font-size-14px{
    font-size: 14px;
  }
  .flex-basis-60 {
    flex-basis: px2rem(110px) !important;
    padding: 0 px2rem(10px);
  }
  padding: px2rem(20px);
  .subTitle {
    font-size: 14px;
    padding: px2rem(20px);
    font-weight: bold;
  }
  .exchageRoom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: px2rem(20px) px2rem(20px);
    background: #fff;
    .pickerBoxs {
      display: flex;
      font-size: 14px;
      margin-top: px2rem(20px);
      align-items: center;
      .dropdownBox {
        margin-left: px2rem(20px);
        .dropdown {
          padding: px2rem(10px);
          border: 1px solid #333;
        }
      }
    }
    .quedingBtn {
      width: px2rem(150px);
      height: px2rem(50px);
      line-height: px2rem(50px);
      background: #03a9f4;
      align-self: center;
      border-radius: px2rem(10px);
      text-align: center;
      color: #fff;
    }
  }
  ////图片上传样式 ------start添加图片
  .upload-imgs{
    margin: 0 px2rem(20px);
    overflow: hidden;
    font-size: 0;
    background: #fff;
    padding: px2rem(20px) px2rem(10px);
  }
  .upload-imgs li{
    position: relative;
    width: px2rem(200px);
    height: px2rem(200px);
    font-size: 14px;
    display: inline-block;
    padding: px2rem(20px);
    margin-right: px2rem(15px);
    border: 1px dashed $them-color;
    text-align: center;
    vertical-align: middle;
  }
  // .upload-imgs li:hover{
  //   border-color: $them-color;
  // }
  .upload-imgs .imgAdd {
    width: px2rem(100px);
    height: px2rem(100px);
  }
  .upload-imgs .add{
    display: block;
    background-color: $them-color;
    width: px2rem(200px);
    height: px2rem(200px);
  }
  .upload-imgs .add .iconfont{
    padding: 10px 0;
    font-size: 40px;
  }
  // .upload-imgs li:hover .add{
  //   background-color: $them-color;
  // }
  .upload-imgs li .upload{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    width: px2rem(200px);
    height: px2rem(300px);
    padding: px2rem(20px);
    margin-top: px2rem(-100px);
  }
  .upload-imgs .img,
  .upload-imgs .img img{
    position: relative;
    width: px2rem(200px);
    height: px2rem(200px);
    line-height: px2rem(200px);
  }
  .upload-imgs .img img{
    vertical-align: middle;
  }
  .upload-imgs .img .close{
    display: none;
  }
  .upload-imgs li .img .close{
    display: block;
    position: absolute;
    right: 0;
    top: 0;
    line-height: 1;
    font-size: px2rem(60px);
    color: #fff;
  }
  //图片上传样式 ------end
  //换寝原因
  .HqTextarea {
    width: px2rem(500px);
    height: px2rem(150px);
    border-radius: px2rem(15px);
    padding: px2rem(20px);
    border: none;
  }
  .telPhone {
    width: px2rem(500px);
    height: px2rem(60px);
    border-radius: px2rem(15px);
    padding: px2rem(20px);
  }
  .margin-bottom {
    margin-bottom: px2rem(100px);
  }
  .listBox {
    .bg-f9b625 {
      background: #f9b625;
    }
    display: flex;
    //缩略图
    .thumbnail {
        width: px2rem(136px);
        height: px2rem(136px);
        margin-right: px2rem(30px);
        border-radius: px2rem(5px);
    }
    //缩略图-长方形
    .thumbnail-max {
        width: px2rem(210px);
        height: px2rem(136px);
        margin-right: px2rem(26px);
        border-radius: px2rem(5px);
    }
    //基本信息栏
    .mesList {
        flex: 1;
        .title {
            display: flex;
            align-items: center;
            flex: 1;
            //列表 标签
            .label {
                flex: none;
                display: inline-block;
                padding: 0 px2rem(15px);
                height: px2rem(32px);
                line-height: px2rem(32px);
                color: #fff;
                border-radius: px2rem(3px);
                margin-right: px2rem(16px);
                margin-left: px2rem(20px);
                font-size: px2rem(22px);
            }
        }
        //标签靠右-标签
        .title-label-right {
            justify-content: space-between;
        }
        p {
            color: #666;
            font-size: px2rem(26px);
            margin-top: px2rem(25px);
        }
    }
  }
}
.case-details{
  .case-list {
    .list {
      display: flex;
      justify-content: space-between;
      .title {
        font-size: px2rem(26px);
        width: px2rem(120px);
      }
      .showitem {
        flex: 1;
        border-left: 2px solid #03a9f4;
        font-size: px2rem(18px);
        // padding: 0 5px 35px 20px;
        padding: 0 px2rem(5px) px2rem(30px) px2rem(20px);
        margin-left: px2rem(30px);
        padding-right: px2rem(20px);
        h4 {
          font-size: px2rem(22px);
          color: #0343a6;
          position: relative;
          margin:0 0 px2rem(15px) px2rem(15px);
        }
        h4:before {
          content: "";
          position: absolute;
          left: px2rem(-50px);
          top: 0px;
          display: block;
          width: px2rem(20px);
          height: px2rem(20px);
          border: 2px solid #03a9f4;
          border-radius: px2rem(20px);
          background: #03a9f4;
        }
        .text {
		      font-size: px2rem(18px);
          margin-left: px2rem(15px);
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// RepairApplyDetial.vue?68ef83c1